// import React, { useRef, useState } from "react";
// import styles from "./votercard.module.css";
// import { RenderAddressValue } from "./VoterAddress";
// import { safe_get } from "../../../report-visuals";
// import { Chip } from "@mui/material";
//
// export const VoterAdditionalInfo = ({ phone, houseno, voterData }) => {
//   const family_members = safe_get(voterData, "family_members", null);
//   const party_support = safe_get(voterData, "insight.party_support", null);
//   return (
//     <>
//       <div className="flex space-x-2 mb-[24px] px-[24px]">
//         {houseno && (
//           <div
//             className={`flex items-center  px-[10px] py-[4px] rounded-[20px] space-x-1 ${styles.bgAdditionalInfo}`}
//           >
//             <img src="/voter/house.png" />
//             <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
//               {houseno}
//             </span>
//           </div>
//         )}
//
//         {phone && phone !== "+91" && (
//           <div
//             className={`flex  items-center px-[10px] py-[4px] rounded-[20px] space-x-1 ${styles.bgAdditionalInfo}`}
//           >
//             <img src="/voter/phone.png" alt="My Example" />
//             <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
//               {phone}
//             </span>
//           </div>
//         )}
//
//         {family_members > 1 ? (
//           <div
//             className={`flex  items-center px-[10px] py-[4px] rounded-[20px] space-x-1 ${styles.bgAdditionalInfo}`}
//           >
//             <img src="/voter/phone.png" alt="My Example" />
//             <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
//               {phone}
//             </span>
//           </div>
//         ) : null}
//         {party_support ? <Chip label={party_support} /> : null}
//       </div>
//     </>
//   );
// };

import React from "react";
import styles from "./votercard.module.css";
import { safe_get } from "../../../report-visuals";
import { Chip } from "@mui/material";

export const VoterAdditionalInfo = ({
  phone,
  houseno,
  voterData,
  availability = "",
  which_city = "",

}) => {
  const family_members = safe_get(voterData, "family_members", null);
  const party_support = safe_get(voterData, "insight.party_support", null);

  return (
    <div className="flex flex-wrap items-center gap-2 mb-[24px] px-[24px]">
      {which_city && which_city !== "" && (
        <div
          className={`flex items-center gap-1 px-[10px] py-[4px] rounded-[20px] ${styles.bgAdditionalInfo}`}
        >
          <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
            Current City {which_city}
          </span>
        </div>
      )}
      {availability && availability !== "" && (
        <div
          className={`flex items-center gap-1 px-[10px] py-[4px] rounded-[20px] ${styles.bgAdditionalInfo}`}
        >
          <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
            Availabilty {availability}
          </span>
        </div>
      )}
      {houseno && (
        <div
          className={`flex items-center gap-1 px-[10px] py-[4px] rounded-[20px] ${styles.bgAdditionalInfo}`}
        >
          <img src="/voter/house.png" className="w-4 h-4" alt="house" />
          <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
            {houseno}
          </span>
        </div>
      )}

      {phone && phone !== "+91" && (
        <div
          className={`flex items-center gap-1 px-[10px] py-[4px] rounded-[20px] ${styles.bgAdditionalInfo}`}
        >
          <img src="/voter/phone.png" className="w-4 h-4" alt="phone" />
          <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
            {phone}
          </span>
        </div>
      )}

      {family_members > 1 && (
        <div
          className={`flex items-center gap-1 px-[10px] py-[4px] rounded-[20px] ${styles.bgAdditionalInfo}`}
        >
          <img src="/img/family.png" className="w-4 h-4" alt="family" />
          <span className="font-normal text-[12px] leading-[14px] text-[#848484]">
            {family_members} Members
          </span>
        </div>
      )}

      {party_support && (
        <Chip
          label={party_support}
          className="!text-[12px] !h-[24px] !rounded-[20px] !bg-[#f0f0f0] !text-[#848484]"
        />
      )}
    </div>
  );
};
